import { defineComponent as h, useSlots as C, openBlock as e, createElementBlock as d, unref as i, renderSlot as c, createCommentVNode as o, createElementVNode as u, createBlock as a, normalizeClass as f, withCtx as l, createTextVNode as y, toDisplayString as m, resolveDynamicComponent as g, mergeProps as T, createVNode as b } from "vue";
import "./ghl-ui.es23.js";
import "./ghl-ui.es36.js";
import "./ghl-ui.es13.js";
import "./ghl-ui.es327.js";
import p from "./ghl-ui.es118.js";
import v from "./ghl-ui.es119.js";
import B from "./ghl-ui.es120.js";
import I from "./ghl-ui.es124.js";
import x from "./ghl-ui.es72.js";
import $ from "./ghl-ui.es75.js";
const S = { class: "hl-header" }, w = {
  key: 0,
  class: "back"
}, A = {
  key: 1,
  class: "header"
}, O = { class: "hl-header-content" }, U = { class: "hl-title-container" }, D = { key: 0 }, N = { key: 0 }, V = { class: "flex" }, j = { class: "space-x-2 flex" }, M = { key: 3 }, E = {
  key: 2,
  class: "footer"
}, F = h({
  name: "UIHeader",
  inheritAttrs: !1
}), H = h({
  ...F,
  props: {
    title: {
      type: String,
      default: ""
    },
    secondaryTitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    primaryText: {
      type: String,
      default: void 0
    },
    secondaryText: {
      type: String,
      default: void 0
    },
    primaryActionIcon: {
      type: Function
    },
    secondaryActionIcon: {
      type: Function
    },
    primaryOptions: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: !0
    },
    primaryButtonConfig: {
      type: Object,
      default: () => ({})
    },
    secondaryButtonConfig: {
      type: Object,
      default: () => ({})
    },
    primaryButtonDropdownConfig: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const n = C();
    return (r, s) => (e(), d("div", S, [
      i(n).back ? (e(), d("div", w, [
        c(r.$slots, "back")
      ])) : o("", !0),
      i(n).header ? (e(), d("div", A, [
        c(r.$slots, "header")
      ])) : o("", !0),
      u("div", O, [
        u("div", U, [
          t.title ? (e(), a(i(p), {
            key: 0,
            class: f(["title", i(n)["title-extra"] ? "title-extra-slots" : ""])
          }, {
            default: l(() => [
              y(m(t.title) + " ", 1),
              i(n)["title-extra"] ? (e(), d("div", D, [
                c(r.$slots, "title-extra")
              ])) : o("", !0)
            ]),
            _: 3
          }, 8, ["class"])) : o("", !0),
          t.secondaryTitle ? (e(), a(i(v), {
            key: 1,
            class: f([i(n)["secondaryTitle-extra"] ? "title-extra-slots" : ""])
          }, {
            default: l(() => [
              y(m(t.secondaryTitle) + " ", 1),
              i(n)["secondaryTitle-extra"] ? (e(), d("div", N, [
                c(r.$slots, "secondaryTitle-extra")
              ])) : o("", !0)
            ]),
            _: 3
          }, 8, ["class"])) : o("", !0),
          t.description ? (e(), a(g(t.secondaryTitle ? i(B) : i(I)), {
            key: 2,
            class: "description max-w-3xl"
          }, {
            default: l(() => [
              y(m(t.description), 1)
            ]),
            _: 1
          })) : o("", !0)
        ]),
        u("div", V, [
          u("div", j, [
            t.secondaryText || t.secondaryActionIcon ? (e(), a(i(x), {
              key: 0,
              onClick: s[0] || (s[0] = (k) => r.$emit("secondaryClick")),
              id: `${t.id}-btn-secondary`,
              loading: t.secondaryButtonConfig.loading,
              disabled: t.secondaryButtonConfig.disabled
            }, {
              default: l(() => [
                (e(), a(g(t.secondaryActionIcon), {
                  class: f(["w-5 h-4", t.secondaryText ? "mr-1" : ""])
                }, null, 8, ["class"])),
                y(" " + m(t.secondaryText), 1)
              ]),
              _: 1
            }, 8, ["id", "loading", "disabled"])) : o("", !0),
            t.primaryText && !t.primaryOptions.length ? (e(), a(i(x), {
              key: 1,
              onClick: s[1] || (s[1] = (k) => r.$emit("primaryClick")),
              type: "primary",
              id: `${t.id}-btn-primary`,
              loading: t.primaryButtonConfig.loading,
              disabled: t.primaryButtonConfig.disabled
            }, {
              default: l(() => [
                (e(), a(g(t.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                y(" " + m(t.primaryText), 1)
              ]),
              _: 1
            }, 8, ["id", "loading", "disabled"])) : o("", !0),
            t.primaryOptions && t.primaryOptions.length ? (e(), a(i($), T({
              key: 2,
              options: t.primaryOptions,
              onSelect: s[2] || (s[2] = (k) => r.$emit("primaryClick", k)),
              id: `${t.id}-dropdown-primary`
            }, t.primaryButtonDropdownConfig), {
              default: l(() => [
                b(i(x), {
                  type: "primary",
                  id: `${t.id}-dropdown-btn-primary`,
                  loading: t.primaryButtonConfig.loading,
                  disabled: t.primaryButtonConfig.disabled
                }, {
                  default: l(() => [
                    (e(), a(g(t.primaryActionIcon), {
                      class: f(["w-5 h-4", t.primaryText ? "mr-1" : ""])
                    }, null, 8, ["class"])),
                    y(" " + m(t.primaryText), 1)
                  ]),
                  _: 1
                }, 8, ["id", "loading", "disabled"])
              ]),
              _: 1
            }, 16, ["options", "id"])) : o("", !0),
            i(n).extra ? (e(), d("div", M, [
              c(r.$slots, "extra")
            ])) : o("", !0)
          ])
        ])
      ]),
      i(n).footer ? (e(), d("div", E, [
        c(r.$slots, "footer")
      ])) : o("", !0)
    ]));
  }
}), Y = H;
export {
  Y as default
};
